import { createFileRoute } from "@tanstack/react-router";

import { AiAppDetailSectionPage } from "@/features/ai-apps/detail/ai-app-detail-section-page";

export const Route = createFileRoute("/ai-apps/$appId/models")({
  component: () => <AiAppDetailSectionPage section="models" />,
});
